import { render, staticRenderFns } from "./RangeSetup.vue?vue&type=template&id=39d9f59e&scoped=true"
import script from "./RangeSetup.vue?vue&type=script&lang=js"
export * from "./RangeSetup.vue?vue&type=script&lang=js"
import style0 from "./RangeSetup.vue?vue&type=style&index=0&id=39d9f59e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d9f59e",
  null
  
)

export default component.exports